import { subHours, isWithinInterval } from 'date-fns';

export default ({ eventStartAt, eventEndAt }) => {
  if (!eventStartAt || !eventEndAt) return false;

  return isWithinInterval(new Date(), {
    start: subHours(new Date(eventStartAt), 1),
    end: new Date(eventEndAt),
  });
};
